import { backgrounds } from "src/assets"
import { BlogPost } from "src/components/BlogPostPreview"

const PARTNERSHIP = "Partnerships"
const COE = "Aether TCG"
const NFT = "NFTs"
const AEG = "Aether Games"
const TOURNAMENT = "Tournament"
const PATCHNOTES = "Patch notes"

// TODO: add dates for posts
// posts with higher order number will come up on top of the blogpost page
export const POSTS: BlogPost[] = [
  // {
  //     title: "Aether Raids",
  //     image: backgrounds.blog.aetherRaidsImg,
  //     url: "/aether-raids",
  //     tags: [COE],
  // },
  // {
  //     order: 2,
  //     title: "Ultra x Aether Games Inc: Raving the frontiers of Web3 together",
  //     image: backgrounds.blog.ultraImg,
  //     url: "/ultra-x-aethergamesinc",
  //     tags: [PARTNERSHIP, AEG],
  //     description: "We're excited to announce our partnership with Ultra! We'll be working together to achieve our goals via streamlining processes for our games and players, connecting symbiotically with Ultra's thoughtful ecosystem.",
  // },
  // {
  //     order: 3,
  //     title: "Ultiverse x Aether Games — cross the ages towards the ultimate future of Blockchain Game Development",
  //     image: backgrounds.blog.ultiverse,
  //     url: "/ultiverse-x-aethergames",
  //     tags: [PARTNERSHIP, AEG],
  //     description: "Big thinkers say that if great minds truly did think alike, we would be living in a dystopia. Ultimately, a futuristic space-age cyberpunk dystopia. Or a dark fantasy one. With this notion in mind, it's no wonder why Aether Games Inc. vision came across the Web3 Universe of Ultiverse.",
  // },
  {
    order: 4,
    title: "How to play Cards Of Eternity",
    image: backgrounds.blog.howToPlay,
    url: "/how-to-play",
    tags: [COE],
    description: "Start of the match // Player's turn // Match end // FAQ",
  },
  {
    order: 5,
    title: "Aether Games Inc: Frequently Asked Questions",
    image: backgrounds.blog.cardsImg,
    url: "/faq",
    tags: [COE, AEG],
    description:
      "Aether Games Inc. is a game development studio, cinema production and publisher for the world of Blockchain and NFTs.",
  },
  {
    order: 6,
    title: "Aether Games Inc. Emotes NFT Utility",
    image: backgrounds.blog.emotesNFTUtility1,
    url: "/emotes-nft-utility",
    tags: [NFT, AEG],
    description:
      "Aether Games Inc. NFT Emotes are unique assets, available to our most active appreciators and community members.",
  },
  {
    order: 7,
    title: "What’s a founderpack for Cards Of Eternity?",
    image: backgrounds.blog.founderpacksBg,
    url: "/founderpack-faq",
    tags: [COE, NFT, AEG],
    description:
      "The Founder Packs are an exclusive and truly unique supply crate for early Cards Of Eternity gamers, adopters, and appreciators, containing both assets for Cards Of Eternity and the upcoming Gates of Ethernity.",
  },
  {
    order: 8,
    title: "Open Beta: Frequently Asked Questions",
    image: backgrounds.blog.openBetaFaqBg,
    url: "/openbeta-faq",
    tags: [COE, NFT, AEG],
    description: "With Early Access just around the corner, we prepared for you the FAQ.",
  },
  // {
  //     order: 9,
  //     title: "Battle Signs: Social Leaderboards",
  //     image: backgrounds.blog.battleSigns,
  //     url: "/battlesigns",
  //     tags: [COE,],
  //     description: "Welcome to Battle Sign Community Chart. Here you can publicly verify your community stats and reward eligibility.",
  // },
  {
    order: 10,
    title: "The Cards Of Eternity $5,000 Tournament has finally arrived",
    image: backgrounds.blog.tournament,
    url: "/tournament",
    tags: [COE, PARTNERSHIP, TOURNAMENT],
    description: "The highly-anticipated Cards Of Eternity (CoE) tournament is finally here.",
  },
  {
    order: 11,
    title: "Cards Of Eternity Pre-Season Tournament",
    image: backgrounds.blog.tournament2,
    url: "/pre-season-tournament",
    tags: [COE, PARTNERSHIP, TOURNAMENT],
    description: "Join the CoE Pre-Season now and win $3000!",
  },
  // {
  //     order: 12,
  //     title: "Aether Games Partners with Mysten Labs to Launch NFT-Backed Gaming Ecosystem",
  //     image: backgrounds.blog.mystenlabs,
  //     url: "/mysten-labs-aether-games",
  //     tags: [COE, PARTNERSHIP,],
  //     description: "Premier Web3 Gaming Studio to Leverage Sui Layer 1 Blockchain to Scale NFT-Powered Gaming Universe",
  // },
  {
    order: 13,
    title: "Cards Of Eternity 0.39.8 Patch Notes",
    image: backgrounds.blog.patches.patch0398,
    url: "/patch-notes-0-39-8",
    tags: [COE, PATCHNOTES],
    description: "Welcome to the 0.39.8 patch for Cards Of Eternity!",
  },
  {
    order: 15,
    title: "Cards Of Eternity 0.4.0 Patch",
    image: backgrounds.blog.patches.patch040,
    url: "/patch-notes-0-4-0",
    tags: [COE, PATCHNOTES],
    description: "Welcome to the 0.4.0 patch for Cards Of Eternity!",
  },
  {
    order: 16,
    title: "Cards Of Eternity 0.4.6 Hotfix",
    image: backgrounds.blog.hotfixes.hotfix046,
    url: "/hotfix-0-4-6",
    tags: [COE, PATCHNOTES],
    description: "We are issuing a hotfix to address certain issues in the meta.",
  },
  {
    order: 17,
    title: "Cards Of Eternity 0.41.5 Patch",
    image: backgrounds.blog.patches.patch0415,
    url: "/patch-notes-0-41-5",
    tags: [COE, PATCHNOTES],
    description: "Welcome to the 0.41.5 patch for Cards Of Eternity!",
  },
  {
    order: 18,
    title: "Deluxe Packs have entered the Cards Of Eternity!",
    image: backgrounds.blog.dpx,
    url: "/deluxe-packs",
    tags: [COE, AEG],
    description: "What's inside? Are they same as Founder Packs? Is there really a difference?",
  },
  {
    order: 19,
    title: "Supercharge your Cards Of Eternity account with the power of Aether Games Discord!",
    image: backgrounds.blog.colToAc.main,
    url: "/col-to-ac",
    tags: [COE, AEG],
    description: "Witness our biggest Discord Community Update since recent times!",
  },
  {
    order: 21,
    title: "Friendship Community Tournament with $1100 prize pool: June 9th-27th",
    image: backgrounds.blog.coeTournament,
    url: "/friendship-tournament-june-9th-27th",
    tags: [COE, TOURNAMENT],
    description:
      "🔥New ongoing community Tournament in Cards Of Eternity: June 9th — June 27th + Airdrop for Leaderboard's Top 100!",
  },
  {
    order: 22,
    title: "Cards Of Eternity 0.42.71 Patch",
    image: backgrounds.blog.patches.patch04270,
    url: "/patch-notes-0-42-71",
    tags: [COE, PATCHNOTES],
    description: "Welcome to the 0.42.71 patch for Cards Of Eternity!",
  },
  {
    order: 23,
    title: "Cards Of Eternity 0.42.75 HOTFIX",
    image: backgrounds.blog.hotfixes.hotfix04275,
    url: "/hotfix-0-42-75",
    tags: [COE, PATCHNOTES],
    description: "We are issuing a hotfix to address certain issues.",
  },
  {
    order: 24,
    title: "Cards Of Eternity 0.43.20 Patch",
    image: backgrounds.blog.patches.patch04320,
    url: "/patch-notes-0-43-20",
    tags: [COE, PATCHNOTES],
    description: "Welcome to the 0.43.20 patch for Cards Of Eternity!",
  },
  {
    order: 25,
    title: "Cards Of Eternity 0.44.15 Patch",
    image: backgrounds.blog.patches.patch04415,
    url: "/patch-notes-0-44-15",
    tags: [COE, PATCHNOTES],
    description: "Welcome to the 0.44.15 patch for Cards Of Eternity!",
  },
  {
    order: 26,
    title: "AETHER 0.45.20 Patch",
    image: backgrounds.blog.patches.patch04520,
    url: "/patch-notes-0-45-20",
    tags: [COE, PATCHNOTES],
    description: "Welcome to the 0.45.20 patch for Aether TCG!",
  },
  {
    order: 27,
    title: "AETHER 0.46.10 Patch",
    image: backgrounds.blog.patches.patch04610,
    url: "/patch-notes-0-46-10",
    tags: [COE, PATCHNOTES],
    description: "Welcome to the 0.46.10 patch for Aether TCG!",
  },
  {
    order: 28,
    title: "AETHER 0.47.25 Patch",
    image: backgrounds.blog.patches.patch04725,
    url: "/patch-notes-0-47-25",
    tags: [COE, PATCHNOTES],
    description: "Welcome to the 0.47.25 patch for Aether TCG!",
  },
  {
    order: 29,
    title: "AETHER 0.48.30 Patch",
    image: backgrounds.blog.patches.patch04830,
    url: "/patch-notes-0-48-30",
    tags: [COE, PATCHNOTES],
    description: "Welcome to the 0.48.30 patch for Aether TCG!",
  },
  {
    order: 30,
    title: "AETHER 0.49.20 Patch",
    image: backgrounds.blog.patches.patch04920,
    url: "/patch-notes-0-49-20",
    tags: [COE, PATCHNOTES],
    description: "Welcome to the 0.49.20 patch for Aether TCG!",
  },
  {
    order: 31,
    title: "AETHER 0.50.12 Patch",
    image: backgrounds.blog.patches.patch05012,
    url: "/patch-notes-0-50-12",
    tags: [COE, PATCHNOTES],
    description: "Welcome to the 0.50.12 patch for Aether TCG!",
  },
  {
    order: 32,
    title: "AETHER 0.51 Patch",
    image: backgrounds.blog.patches.patch051,
    url: "/patch-notes-0-51",
    tags: [COE, PATCHNOTES],
    description: "Welcome to the 0.51 patch for Aether TCG!",
  },
  {
    order: 33,
    title: "AETHER 0.51.45 Patch",
    image: null,
    url: "/patch-notes-0-51-45",
    tags: [COE, PATCHNOTES],
    description: "Welcome to the 0.51.45 patch for Aether TCG!",
  },
  {
    order: 34,
    title: "AETHER 0.52 Patch",
    image: backgrounds.blog.patches.patch052,
    url: "/patch-notes-0-52",
    tags: [COE, PATCHNOTES],
    description: "Welcome to the 0.52 patch for Aether TCG!",
  },
  {
    order: 35,
    title: "Cards Of Eternity 1.0 Patch Notes",
    image: backgrounds.blog.patches.patch10,
    url: "/patch-notes-1-0",
    tags: [COE, PATCHNOTES],
    description: "Welcome to the 1.0 patch for Cards Of Eternity: Wheel of Time!",
  },
]
